import React from 'react';
import PropTypes from 'prop-types';
// Sweet Alert
import swal from 'sweetalert';

/**
 * Wrapper component for sweetalert plugin
 */
const Swal = props => {

    const handleClick = e => {
        e.preventDefault();
        // pass swal reference so is possible to chain popups
        swal(props.options).then(p => props.callback(p, swal,id));
    }

    const { id,callback, ...rest } = props;

    if (props.disabled) {
        return (
            <div {...rest} >
                {props.children}
            </div>
        )
    } else {
         return (
            <div {...rest} onClick={handleClick} >
                {props.children}
            </div>
        )
    }
}

Swal.Show = props =>  {
    swal(props.options).then(p => props.callback(p, swal,props.id));
}

Swal.propType = {
    
    /** swal options object */
    options: PropTypes.object.isRequired,
    /** callback function for swal response */
    callback: PropTypes.func,
    id : PropTypes.number
}

Swal.defaultProps = {
    callback: () => {},

}

export default Swal;
